/**
 * Texto visible de los enums, y su pastilla.
 *
 * El enum tipado va a la base; el texto visible vive AQUI y nunca se guarda.
 * Son dos cosas distintas: cambiar "Cerrado con firma" por otra palabra no
 * debe migrar ninguna fila.
 */

export const TXT_TKT: Record<string, string> = {
  TKT_ABIERTO: 'Abierto',
  TKT_ASIGNADO: 'Asignado',
  TKT_ETA: 'ETA a sitio',
  TKT_ARRIBO: 'Arribo',
  TKT_EN_TRABAJO: 'En trabajo',
  TKT_EVIDENCIAS: 'Captura de evidencias',
  TKT_CERRADO: 'Cerrado con firma',
  TKT_VISITA_FALSA: 'Visita en falso',
  TKT_CIERRE_ADMINISTRATIVO: 'Cierre administrativo',
  TKT_CANCELADO: 'Cancelado',
};

export const CLS_TKT: Record<string, string> = {
  TKT_ABIERTO: 't-cold',
  TKT_ASIGNADO: 't-cold',
  TKT_ETA: 't-cold',
  TKT_ARRIBO: 't-warm',
  TKT_EN_TRABAJO: 't-warm',
  TKT_EVIDENCIAS: 't-warm',
  TKT_CERRADO: 't-ok',
  TKT_VISITA_FALSA: 't-hot',
  TKT_CIERRE_ADMINISTRATIVO: 't-mute',
  TKT_CANCELADO: 't-mute',
};

/* Color de cada estatus en las graficas. Vive junto al enum para que una
   grafica nueva no invente su propia paleta. */
export const COLOR_TKT: Record<string, string> = {
  TKT_ABIERTO: '#4f8cff',
  TKT_ASIGNADO: '#38bdf8',
  TKT_ETA: '#60a5fa',
  TKT_ARRIBO: '#a78bfa',
  TKT_EN_TRABAJO: '#f5a524',
  TKT_EVIDENCIAS: '#fbbf24',
  TKT_CERRADO: '#2ecc8f',
  TKT_VISITA_FALSA: '#f4515b',
  TKT_CIERRE_ADMINISTRATIVO: '#8b94a7',
  TKT_CANCELADO: '#8b94a7',
};

/* La prioridad del ticket. Vivia suelta dentro de Analitica; en cuanto la
   torre de control la necesito tambien, copiarla habria sido tener dos
   verdades sobre como se llama PRI_CRITICA en pantalla. */
export const TXT_PRI: Record<string, string> = {
  PRI_CRITICA: 'Critica',
  PRI_ALTA: 'Alta',
  PRI_MEDIA: 'Media',
  PRI_BAJA: 'Baja',
};

export const TXT_ORIGEN: Record<string, string> = {
  TKT_ROLLOUT: 'Rollout',
  TKT_ONDEMAND: 'On demand',
  TKT_EXCEDENTE: 'Excedente de poliza',
};

export const TXT_VISITA: Record<string, string> = {
  VIS_PROGRAMADA: 'Programada',
  VIS_EN_CURSO: 'En curso',
  VIS_ATENDIDA: 'Atendida',
  VIS_SIN_ACCESO: 'Sin acceso',
  VIS_REPROGRAMADA: 'Reprogramada',
  VIS_CANCELADA: 'Cancelada',
};

export const CLS_VISITA: Record<string, string> = {
  VIS_PROGRAMADA: 't-cold',
  VIS_EN_CURSO: 't-warm',
  VIS_ATENDIDA: 't-ok',
  VIS_SIN_ACCESO: 't-hot',
  VIS_REPROGRAMADA: 't-warm',
  VIS_CANCELADA: 't-mute',
};

export const TXT_PERFIL: Record<string, string> = {
  PERFIL_ADMIN: 'Administrador total',
  PERFIL_GERENTE: 'Gerente de proyectos',
  PERFIL_DESPACHADOR: 'Despachador · torre de control',
  PERFIL_PLANEACION: 'Planeacion de ingenieria',
  PERFIL_CLIENTE: 'Cliente',
};

export const TXT_UBICACION: Record<string, string> = {
  UBI_ALMACEN: 'En almacen',
  UBI_TRANSITO: 'En transito',
  UBI_INSTALADA: 'Instalada en sitio',
  UBI_BAJA: 'Dada de baja',
};

export const TXT_GUIA: Record<string, string> = {
  GUIA_GENERADA: 'Generada',
  GUIA_RECOLECTADA: 'Recolectada',
  GUIA_TRANSITO: 'En transito',
  GUIA_ENTREGADA: 'Entregada',
  GUIA_INCIDENCIA: 'Con incidencia',
};

export const CLS_GUIA: Record<string, string> = {
  GUIA_GENERADA: 't-mute',
  GUIA_RECOLECTADA: 't-cold',
  GUIA_TRANSITO: 't-warm',
  GUIA_ENTREGADA: 't-ok',
  GUIA_INCIDENCIA: 't-hot',
};

/** Texto visible de un enum, con el enum crudo como respaldo visible. */
export function txt(mapa: Record<string, string>, clave: string | null | undefined): string {
  if (!clave) return '—';
  return mapa[clave] ?? clave;
}

/* --------------------------- Modulo comercial ---------------------------- */

export const TXT_CTR_TIPO: Record<string, string> = {
  CTR_POLIZA: 'Poliza',
  CTR_PLAN_ROLLOUT: 'Plan de rollout',
};

export const TXT_CTR_ESTADO: Record<string, string> = {
  CTR_VIGENTE: 'Vigente',
  CTR_POR_VENCER: 'Por vencer',
  CTR_VENCIDO: 'Vencido',
  CTR_SUSPENDIDO: 'Suspendido',
};

export const CLS_CTR_ESTADO: Record<string, string> = {
  CTR_VIGENTE: 't-ok',
  CTR_POR_VENCER: 't-warm',
  CTR_VENCIDO: 't-hot',
  CTR_SUSPENDIDO: 't-mute',
};

export const TXT_CTR_PERIODO: Record<string, string> = {
  CTR_MENSUAL: 'Mensual',
  CTR_PROYECTO: 'Por proyecto',
};

export const TXT_PRY: Record<string, string> = {
  PRY_PLANEACION: 'En planeacion',
  PRY_EN_EJECUCION: 'En ejecucion',
  PRY_EN_RIESGO: 'En riesgo',
  PRY_SUSPENDIDO: 'Suspendido',
  PRY_CERRADO: 'Cerrado',
};

export const CLS_PRY: Record<string, string> = {
  PRY_PLANEACION: 't-cold',
  PRY_EN_EJECUCION: 't-ok',
  PRY_EN_RIESGO: 't-hot',
  PRY_SUSPENDIDO: 't-warm',
  PRY_CERRADO: 't-mute',
};

export const TXT_SITIO: Record<string, string> = {
  SITIO_ALTA: 'Dado de alta',
  SITIO_INCOMPLETO: 'Incompleto',
  SITIO_DUPLICADO: 'Duplicado',
  SITIO_VALIDADO: 'Validado',
  SITIO_BAJA: 'Baja',
};

export const CLS_SITIO: Record<string, string> = {
  SITIO_ALTA: 't-cold',
  SITIO_INCOMPLETO: 't-warm',
  SITIO_DUPLICADO: 't-hot',
  SITIO_VALIDADO: 't-ok',
  SITIO_BAJA: 't-mute',
};

/* ------------------------------ Ingenieria ------------------------------- */

export const TXT_IDC_MODALIDAD: Record<string, string> = {
  IDC_FIJO: 'Fijo por sueldo',
  IDC_FLOTANTE: 'Flotante por evento',
};

export const TXT_IDC_ESTATUS: Record<string, string> = {
  IDC_ACTIVO: 'Activo',
  IDC_INACTIVO: 'Inactivo',
  IDC_BLOQUEADO: 'Bloqueado',
};

export const CLS_IDC_ESTATUS: Record<string, string> = {
  IDC_ACTIVO: 't-ok',
  IDC_INACTIVO: 't-mute',
  IDC_BLOQUEADO: 't-hot',
};

export const TXT_EPP: Record<string, string> = {
  EPP_COMPLETO: 'Completo',
  EPP_PARCIAL: 'Parcial',
  EPP_SIN: 'Sin equipo',
};

export const CLS_EPP: Record<string, string> = {
  EPP_COMPLETO: 't-ok',
  EPP_PARCIAL: 't-warm',
  EPP_SIN: 't-hot',
};

/* ------------------------------- Inventario ------------------------------ */

export const TXT_MOV: Record<string, string> = {
  MOV_ENTRADA: 'Entrada',
  MOV_SALIDA: 'Salida',
  MOV_TRASPASO: 'Traspaso entre almacenes',
  MOV_DOTACION: 'Dotacion a resguardo',
  MOV_INSTALADO: 'Instalado en sitio',
  MOV_RETIRADO: 'Retirado de sitio',
  MOV_REFACCION: 'Refaccion consumida',
  MOV_AJUSTE: 'Ajuste de inventario',
};

export const CLS_MOV: Record<string, string> = {
  MOV_ENTRADA: 't-ok',
  MOV_SALIDA: 't-warm',
  MOV_TRASPASO: 't-cold',
  MOV_DOTACION: 't-cold',
  MOV_INSTALADO: 't-ok',
  MOV_RETIRADO: 't-warm',
  MOV_REFACCION: 't-warm',
  MOV_AJUSTE: 't-hot',
};

export const TXT_ART: Record<string, string> = {
  ART_EQUIPO: 'Equipo',
  ART_REFACCION: 'Refaccion',
  ART_CONSUMIBLE: 'Consumible',
};

/* -------------------------------- Auditoria ------------------------------ */

/**
 * El verbo de una accion de auditoria. La accion guardada es
 * ENTIDAD_VERBO —CLIENTE_ALTA, SITIO_IMPORTACION—, asi que el texto visible
 * se arma del sufijo en vez de enumerar cuarenta combinaciones que se
 * quedarian cortas con la primera entidad nueva.
 */
export const TXT_VERBO: Record<string, string> = {
  ALTA: 'Alta',
  EDICION: 'Edicion',
  BAJA: 'Baja',
  IMPORTACION: 'Importacion',
  TRANSICION: 'Cambio de estatus',
  CIERRE: 'Cierre',
  VISITA: 'Visita',
  DESPACHO: 'Despacho',
  RECEPCION: 'Recepcion',
  INCIDENCIA: 'Incidencia',
  ACCESO: 'Acceso',
  SALIDA: 'Cierre de sesion',
  INICIADA: 'Inicio de sesion',
  CERRADA: 'Cierre de sesion',
  DESPACHADA: 'Despacho',
  RECIBIDA: 'Recepcion',
  ORIGEN: 'Devolucion al origen',
};

export const CLS_VERBO: Record<string, string> = {
  ALTA: 't-ok',
  EDICION: 't-cold',
  BAJA: 't-hot',
  IMPORTACION: 't-cold',
  TRANSICION: 't-warm',
  INCIDENCIA: 't-hot',
};

/** Parte la accion en entidad y verbo: CLIENTE_ALTA -> {CLIENTE, ALTA}. */
export function partirAccion(accion: string): { entidad: string; verbo: string } {
  const corte = accion.lastIndexOf('_');
  if (corte < 1) return { entidad: accion, verbo: '' };
  return { entidad: accion.slice(0, corte), verbo: accion.slice(corte + 1) };
}

/* =========================================================================
   Second touch: los textos y las clases de sus enums.

   Portado de la rama `second-touch` (PR #14). Son los nombres que ve la
   persona; los valores crudos no salen a la pantalla nunca.
   ========================================================================= */

export const TXT_EQP: Record<string, string> = {
  EQP_VIRGEN: 'Virgen, sin imagen',
  EQP_EN_PROCESO: 'En proceso de carga',
  EQP_LISTO: 'Listo para embarcar',
  EQP_EMBARCADO: 'Embarcado',
  EQP_INSTALADO: 'Instalado en sitio',
  EQP_ERROR: 'Con error, a revisar con el proveedor',
  EQP_RETIRADO: 'Retirado',
};

export const CLS_EQP: Record<string, string> = {
  EQP_VIRGEN: 't-mute',
  EQP_EN_PROCESO: 't-warm',
  EQP_LISTO: 't-cold',
  EQP_EMBARCADO: 't-cold',
  EQP_INSTALADO: 't-ok',
  EQP_ERROR: 't-hot',
  EQP_RETIRADO: 't-mute',
};

export const COLOR_EQP: Record<string, string> = {
  EQP_VIRGEN: '#8b94a7',
  EQP_EN_PROCESO: '#fb923c',
  EQP_LISTO: '#0ea5e9',
  EQP_EMBARCADO: '#7c8cf8',
  EQP_INSTALADO: '#2ecc8f',
  EQP_ERROR: '#f4515b',
  EQP_RETIRADO: '#5b6479',
};

export const TXT_CARGA: Record<string, string> = {
  CAR_PENDIENTE: 'Pendiente',
  CAR_OK: 'Cargado y validado',
  CAR_ERROR: 'Error de carga',
};

export const CLS_CARGA: Record<string, string> = {
  CAR_PENDIENTE: 't-mute',
  CAR_OK: 't-ok',
  CAR_ERROR: 't-hot',
};

export const TXT_REMESA: Record<string, string> = {
  REM_ABIERTA: 'Abierta',
  REM_EN_CARGA: 'En carga',
  REM_VALIDADA: 'Validada',
  REM_CERRADA: 'Cerrada',
};

export const CLS_REMESA: Record<string, string> = {
  REM_ABIERTA: 't-mute',
  REM_EN_CARGA: 't-warm',
  REM_VALIDADA: 't-cold',
  REM_CERRADA: 't-ok',
};

export const TXT_RECEPCION: Record<string, string> = {
  REC_ABIERTA: 'En conteo',
  REC_CUADRADA: 'Cuadrada',
  REC_DIFERENCIA: 'Con diferencia',
};

export const CLS_RECEPCION: Record<string, string> = {
  REC_ABIERTA: 't-warm',
  REC_CUADRADA: 't-ok',
  /* Naranja y no rojo: una diferencia no es una falla del proceso, es algo
     que hay que reclamarle al proveedor, y el rojo esta reservado para lo que
     salio mal de nuestro lado. */
  REC_DIFERENCIA: 't-hot',
};

export const TXT_MODALIDAD: Record<string, string> = {
  STG_FACILIDAD: 'En facilidad Enteratek',
  STG_SITIO: 'En sitio destino',
};

export const TXT_ALM: Record<string, string> = {
  ALM_CEDIS: 'CEDIS',
  ALM_RESGUARDO: 'Resguardo de IDC',
  ALM_FACILIDAD: 'Facilidad de staging',
};

export const CLS_ALM: Record<string, string> = {
  ALM_CEDIS: 't-ok',
  ALM_RESGUARDO: 't-cold',
  ALM_FACILIDAD: 't-warm',
};

export const TXT_DOCUMENTO: Record<string, string> = {
  DOC_MANUAL: 'Manual',
  DOC_PLANO: 'Plano',
  DOC_PROCEDIMIENTO: 'Procedimiento',
  DOC_CONTRATO: 'Contrato',
  DOC_ACTA: 'Acta',
  DOC_OTRO: 'Otro',
};

export const TXT_DESTINO_GUIA: Record<string, string> = {
  GUI_ALMACEN: 'Almacen',
  GUI_SITIO: 'Sitio',
};
